import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d481b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 棋譜情報 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 指し手コメント ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 思考 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 形勢グラフ ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 最小化 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-border" }, null, -1))
const _hoisted_9 = { class: "tab-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_RecordInfo = _resolveComponent("RecordInfo")!
  const _component_RecordComment = _resolveComponent("RecordComment")!
  const _component_EngineAnalytics = _resolveComponent("EngineAnalytics")!
  const _component_EvaluationChart = _resolveComponent("EvaluationChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.activeTab === 'invisible')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(`height: calc(100% - ${_ctx.headerHeight}px);`)
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["tab", { selected: _ctx.activeTab === 'recordInfo' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSelect('recordInfo')))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "recordInfo"
          }),
          _hoisted_3
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["tab", { selected: _ctx.activeTab === 'comment' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSelect('comment')))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "comment"
          }),
          _hoisted_4
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["tab", { selected: _ctx.activeTab === 'search' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSelect('search')))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "brain"
          }),
          _hoisted_5
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["tab", { selected: _ctx.activeTab === 'chart' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSelect('chart')))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "chart"
          }),
          _hoisted_6
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["tab", { selected: _ctx.activeTab === 'invisible' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSelect('invisible')))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "arrowDrop"
          }),
          _hoisted_7
        ], 2)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_RecordInfo, {
          class: _normalizeClass(["tab-content", { selected: _ctx.activeTab === 'recordInfo' }]),
          size: _ctx.contentSize
        }, null, 8, ["class", "size"]),
        _createVNode(_component_RecordComment, {
          class: _normalizeClass(["tab-content", { selected: _ctx.activeTab === 'comment' }])
        }, null, 8, ["class"]),
        _createVNode(_component_EngineAnalytics, {
          class: _normalizeClass(["tab-content", { selected: _ctx.activeTab === 'search' }]),
          size: _ctx.contentSize
        }, null, 8, ["class", "size"]),
        _createVNode(_component_EvaluationChart, {
          class: _normalizeClass(["tab-content", { selected: _ctx.activeTab === 'chart' }]),
          size: _ctx.contentSize
        }, null, 8, ["class", "size"])
      ])
    ])
  ]))
}